// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"bd42cda981374001","960":"aa7ed8b47a9a70ba"}[chunkId] + ".css";
};